import React from "react";
import { ManageCouponCodesComponent } from "../../../components/manage-coupon-codes-components/ManageCouponCodesComponent";

export const CouponCodesContainer: React.FC = () => {
  return <ManageCouponCodesComponent />;
};
